import React from "react";

const STAR_PATH = "M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z";

interface StarProps {
  className: string;
  size: string;
  delay: string;
  style?: React.CSSProperties;
}

const Star: React.FC<StarProps> = ({ className, size, delay, style }) => (
  <div className={`absolute animate-star-twinkle ${className}`} style={{ animationDelay: delay, ...style }}>
    <svg className={`${size} drop-shadow-lg`} fill="currentColor" viewBox="0 0 24 24">
      <path d={STAR_PATH} />
    </svg>
  </div>
);

interface DiscountBadgeProps {
  text: string;
}

const DiscountBadge: React.FC<DiscountBadgeProps> = ({ text }) => (
  <div className="absolute top-0 right-0 z-20 transform translate-x-4 -translate-y-4">
    <div className="relative">
      <div className="absolute inset-0 bg-gradient-to-br from-[#e67e22] to-[#d35400] rounded-full blur-xl opacity-60 animate-pulse" style={{ animationDuration: '1.5s' }} />

      <div className="absolute inset-0 animate-rotate-stars" style={{ width: '140%', height: '140%', left: '-20%', top: '-20%' }}>
        <Star className="top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2" size="w-6 h-6" delay="0s" style={{ color: '#fde047' }} />
        <Star className="right-0 top-1/2 transform translate-x-1/2 -translate-y-1/2" size="w-5 h-5" delay="0.3s" style={{ color: '#fef08a' }} />
        <Star className="bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2" size="w-6 h-6" delay="0.6s" style={{ color: '#fde047' }} />
        <Star className="left-0 top-1/2 transform -translate-x-1/2 -translate-y-1/2" size="w-5 h-5" delay="0.9s" style={{ color: '#fef08a' }} />
        <Star className="top-1/4 right-1/4" size="w-4 h-4" delay="1.2s" style={{ color: '#fde047' }} />
        <Star className="bottom-1/4 left-1/4" size="w-4 h-4" delay="1.5s" style={{ color: '#fef08a' }} />
      </div>

      <div className="relative bg-gradient-to-br from-[#e67e22] via-[#e67e22] to-[#d35400] rounded-full w-28 h-28 md:w-32 md:h-32 flex items-center justify-center shadow-[0_10px_40px_rgba(230,126,34,0.6)] border-[4px] border-white transform rotate-12 hover:rotate-6 hover:scale-110 transition-all duration-300 animate-bounce" style={{ animationDuration: '2s', animationIterationCount: 'infinite' }}>
        <span className="text-white font-bold text-2xl md:text-3xl drop-shadow-[0_2px_4px_rgba(0,0,0,0.3)] relative z-10">
          {text}
        </span>
        <div className="absolute inset-0 rounded-full bg-gradient-to-br from-transparent via-white/30 to-transparent opacity-50 animate-shimmer" />
      </div>
    </div>
  </div>
);

export default DiscountBadge;
